import React from "react";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  image: {
    margin: 4,
    borderRadius: "50%",
    border: `1px solid ${theme.iconColor}`,
  },
});

const DriverImage = ({ driverImage, classes, customStyle }) => {
  return (
    <>
      {driverImage ? (
        <img
          src={driverImage}
          alt=""
          className={`${classes.image} ${customStyle.imgStyle}`}
          width="132px"
          height="132px"
        />
      ) : (
        <AccountCircleOutlinedIcon className={customStyle.driverImg} />
      )}
    </>
  );
};

export default withStyles(styles)(DriverImage);
